import React, { useState } from "react";
import { Box, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import useDebounce from "hooks/useDebounce";

import { SEARCH_DEBOUNCE_MS } from "../../constants";

interface ListToolbarProps {
  placeholder: string;
  onSearch: (search: string) => void;
  // Filters shown beside the search box.
  children?: React.ReactNode;
}

const ListToolbar: React.FC<ListToolbarProps> = ({
  placeholder,
  onSearch,
  children,
}) => {
  const [value, setValue] = useState("");
  const debouncedSearch = useDebounce(onSearch, SEARCH_DEBOUNCE_MS);

  return (
    <Box
      display="flex"
      flexWrap="wrap"
      alignItems="center"
      gap={1.5}
      px={{ xs: 2, md: 3 }}
      py={1.5}
    >
      <TextField
        size="small"
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          debouncedSearch(e.target.value.trim());
        }}
        sx={{
          flex: "1 1 240px",
          maxWidth: 420,
          "& .MuiInputBase-input": { fontSize: { xs: 16, sm: 14 } },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
      />
      {children}
    </Box>
  );
};

export default ListToolbar;
